<template>
  <div class="page">
    <div class="header">{{ headerTitle }}</div>
    <div
      class="list-donation"
      v-if="visibleDonations"
    >
      <div>
        <ItemSummary
          :totalDonations="donorStore.totalDonations"
          :totalAmountDonated="donorStore.totalAmountDonated"
        />
        <div
          class="tabs"
          v-if="donorStore.featureRecurringDonations"
        >
          <h3
            class="tab tab-name"
            :style="{ '--main-color': donorStore.mainColor }"
            :class="{ active: selectedTab === 'completedDonations' }"
            @click="selectTab('completedDonations')"
          >
            {{ completedDonationsTabName || 'Completed Donations' }}
          </h3>
          <h3
            class="tab tab-name"
            :style="{ '--main-color': donorStore.mainColor }"
            :class="{ active: selectedTab === 'recurringDonations' }"
            @click="selectTab('recurringDonations')"
          >
            {{ completedDonationsTabName || 'Manage Recurring Donations' }}
          </h3>
        </div>
      </div>
      <CompletedDonations v-if="selectedTab === 'completedDonations'" />
      <RecurringDonations v-if="selectedTab === 'recurringDonations' && donorStore.featureRecurringDonations" />
    </div>
  </div>
</template>
<script setup>
import { ref, computed, watch } from 'vue';
import { useDonorStore } from '@/stores/DonorStore.js';
import { useAuthStore } from '@/stores/AuthStore.js';
import CompletedDonations from './components/CompletedDonations.vue';
import RecurringDonations from './components/RecurringDonations.vue';
import ItemSummary from '@/components/data/ItemSummary.vue';

const donorStore = useDonorStore();
const visibleDonations = ref([]);

const selectedTab = ref('completedDonations');

const props = defineProps({
  completedDonationsTabName: String,
  recurringDonationsTabName: String,
  displayCompleteDonations: Boolean,
  displayRecurringDonations: Boolean,
});

// Check which tab to select
function updateSelectedTab() {
  if (props.displayCompleteDonations) {
    selectedTab.value = 'completedDonations';
  } else if (props.displayRecurringDonations) {
    selectedTab.value = 'recurringDonations';
  }
}

// Initial check
updateSelectedTab();

// Watch for changes in props
watch(() => [props.displayCompleteDonations, props.displayRecurringDonations], updateSelectedTab);

function selectTab(tab) {
  selectedTab.value = tab;
}

const authStore = useAuthStore();

const headerTitle = computed(() => {
  return authStore.type === 'companyAccount' ? 'Employee Giving' : 'Donation History';
});
</script>
<style lang="scss" scoped>
.totals {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.list-donation {
  max-width: 930px;
}
.tabs {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  flex-wrap: wrap;
  gap: 80px;
}
.tab {
  cursor: pointer;
  margin: 10px;
}
.tab-name {
  color: #000;
  text-align: center;
  font: 600 20px Poppins;
}
.tab:hover,
.tab.active {
  padding-bottom: 5px;
  border-bottom: 3px solid var(--main-color);
  margin-bottom: 20px;
}

@media (max-width: 1024px) {
  .list-donation {
    max-width: 680px;
  }
  .tabs {
    gap: 40px;
  }
}

@media (max-width: 600px) {
  .list-donation {
    max-width: 100%;
  }
  .tabs {
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
  .tab {
    margin: 5px;
  }
  .tabs .tab.tab-name {
    font-size: 20px;
  }
}
</style>
